import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlertComponent, DisplayInputComponent } from '@components';

import { Status } from '@enums';
import { BankingDetails, User } from '@models';
import { UtilService } from '@services';
import * as UserActions from '@state/user/user.actions';

@Component({
  selector: 'app-user-banking-details',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    DisplayInputComponent,
    MatProgressSpinnerModule,
    MatGridListModule,
    AlertComponent,
  ],
  templateUrl: './banking-details.component.html',
  styleUrl: './banking-details.component.scss',
})
export class UserBankingDetailsComponent implements OnChanges {
  @Input() user: User | null = null;

  public bankingDetails: BankingDetails | undefined;

  public loading: boolean = false;
  public error: string | null = '';

  constructor(public utils: UtilService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.user && this.user.bankingDetails) {
      this.bankingDetails = this.user.bankingDetails;
    }
  }

  public async onApproveClicked() {
    this.saveStatus(Status.APPROVED);
  }

  public async onDeclineClicked() {
    this.saveStatus(Status.DECLINED);
  }

  private async saveStatus(status: Status) {
    this.error = '';
    this.loading = true;

    try {
      const bankingDetails = this.bankingDetails!;
      await this.utils.actionsToPromise(
        UserActions.setUserBankingDetailsStatus({ bankingDetails, status }),
        UserActions.setUserBankingDetailsStatusSuccess,
        UserActions.setUserBankingDetailsStatusFailed
      );
    } catch (err: any) {
      this.error = this.utils.getErrorMessage(err);
    }

    this.loading = false;
  }
}
